export class SozlesmeEntity {
    sozlesme_id!:number;
    name!:string;
    context_data!:string;
    created_at!:string;
    updated_at!:string;
}